import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/@shared';
import { CreateRoutingModule } from './create-profile-routing.module';
import { CreateProfileComponent } from './create-profile.component';
import { UserProfilesStore } from '../user-profiles-service/user-profiles-service.store';
import { UserProfilesSharedModule } from '../@shared';

@NgModule({
  declarations: [CreateProfileComponent],
  imports: [
    CommonModule,
    CreateRoutingModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    UserProfilesSharedModule,
    SharedModule,
  ],
  providers: [UserProfilesStore],
})
export class CreateProfileModule {}
